/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ORGANISATION_PLACEHOLDER,
  REGISTER_PLACEHOLDER,
} from '@assetaccountant/core/http-token.interceptor';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { DownloadRegisterReportQuery } from '../models/reports/download-register-report.query';
import { ListRegisterReportStatusQuery } from '../models/reports/list-register-report-status.query';
import { ListReportStatusResponse } from '../models/reports/list-report-status.response';
import { QueueAcquisitionsReportCommand } from '../models/reports/queue-acquisitions-report.command';
import { QueueAssetExportReportCommand } from '../models/reports/queue-asset-export-report.command';
import { QueueAssetGroupSummaryReportCommand } from '../models/reports/queue-asset-group-summary-report.command';
import { QueueAssetScheduleReportCommand } from '../models/reports/queue-asset-schedule-report.command';
import { QueueAssetSummaryReportCommand } from '../models/reports/queue-asset-summary-report.command';
import { QueueClassificationSplitReportCommand } from '../models/reports/queue-classification-split-report.command';
import { QueueDepreciationForecastReportCommand } from '../models/reports/queue-depreciation-forecast-report.command';
import { QueueDisposalsReportCommand } from '../models/reports/queue-disposals-report.command';
import { QueueImpairmentReportCommand } from '../models/reports/queue-impairment-report.command';
import { QueueReportResponse } from '../models/reports/queue-report.response';
import { QueueRevaluationMovementsReportCommand } from '../models/reports/queue-revaluation-movements-report.command';
import { QueueTaxAuditReportCommand } from '../models/reports/queue-tax-audit-report.command';
import { QueueTaxAutomateReportCommand } from '../models/reports/queue-tax-automate-report.command';
import { ReportRestrictionQueryV4 } from '../models/reports/report-restriction-query-v4';
import { ReportRestrictionResponse } from '../models/reports/report-restriction.response';

@Injectable({
  providedIn: 'root',
})
export class ReportV4Api {
  constructor(private http: HttpClient) {}

  checkReportRestrictions(
    command: ReportRestrictionQueryV4 = {},
  ): Observable<ReportRestrictionResponse> {
    return this.http.get<ReportRestrictionResponse>(
      `${environment.servicesApiUrl}/api/v4/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/reports/report-restrictions`,
    );
  }

  downloadReport(query: DownloadRegisterReportQuery): Observable<Blob> {
    return this.http.get(
      `${environment.servicesApiUrl}/api/v4/organisations/${query.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${query.registerId ?? REGISTER_PLACEHOLDER}/reports/${query.requestId}/download`,
      { responseType: 'blob' },
    );
  }

  listRegisterReports(
    query: ListRegisterReportStatusQuery = {},
  ): Observable<ListReportStatusResponse> {
    return this.http.get<ListReportStatusResponse>(
      `${environment.servicesApiUrl}/api/v4/organisations/${query.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${query.registerId ?? REGISTER_PLACEHOLDER}/reports`,
    );
  }

  queueAcquisitionsReport(
    command: QueueAcquisitionsReportCommand,
  ): Observable<QueueReportResponse> {
    return this.http.post<QueueReportResponse>(
      `${environment.servicesApiUrl}/api/v4/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/reports/acquisitions`,
      command,
    );
  }

  queueAssetExportReport(command: QueueAssetExportReportCommand): Observable<QueueReportResponse> {
    return this.http.post<QueueReportResponse>(
      `${environment.servicesApiUrl}/api/v4/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/reports/asset-export`,
      command,
    );
  }

  queueAssetGroupSummaryReport(
    command: QueueAssetGroupSummaryReportCommand,
  ): Observable<QueueReportResponse> {
    return this.http.post<QueueReportResponse>(
      `${environment.servicesApiUrl}/api/v4/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/reports/asset-group-summary`,
      command,
    );
  }

  queueAssetScheduleReport(
    command: QueueAssetScheduleReportCommand,
  ): Observable<QueueReportResponse> {
    return this.http.post<QueueReportResponse>(
      `${environment.servicesApiUrl}/api/v4/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/reports/asset-schedule`,
      command,
    );
  }

  queueAssetSummaryReport(
    command: QueueAssetSummaryReportCommand,
  ): Observable<QueueReportResponse> {
    return this.http.post<QueueReportResponse>(
      `${environment.servicesApiUrl}/api/v4/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/reports/asset-summary`,
      command,
    );
  }

  queueClassificationSplitReport(
    command: QueueClassificationSplitReportCommand,
  ): Observable<QueueReportResponse> {
    return this.http.post<QueueReportResponse>(
      `${environment.servicesApiUrl}/api/v4/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/reports/classification-split-report`,
      command,
    );
  }

  queueDepreciationForecastReport(
    command: QueueDepreciationForecastReportCommand,
  ): Observable<QueueReportResponse> {
    return this.http.post<QueueReportResponse>(
      `${environment.servicesApiUrl}/api/v4/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/reports/depreciation-forecast`,
      command,
    );
  }

  queueDisposalsReport(command: QueueDisposalsReportCommand): Observable<QueueReportResponse> {
    return this.http.post<QueueReportResponse>(
      `${environment.servicesApiUrl}/api/v4/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/reports/disposals`,
      command,
    );
  }

  queueImpairmentReport(command: QueueImpairmentReportCommand): Observable<QueueReportResponse> {
    return this.http.post<QueueReportResponse>(
      `${environment.servicesApiUrl}/api/v4/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/reports/impairment-report`,
      command,
    );
  }

  queueRevaluationMovementsReport(
    command: QueueRevaluationMovementsReportCommand,
  ): Observable<QueueReportResponse> {
    return this.http.post<QueueReportResponse>(
      `${environment.servicesApiUrl}/api/v4/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/reports/revaluation-movements-report`,
      command,
    );
  }

  queueTaxAuditReport(command: QueueTaxAuditReportCommand): Observable<QueueReportResponse> {
    return this.http.post<QueueReportResponse>(
      `${environment.servicesApiUrl}/api/v4/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/reports/tax-audit`,
      command,
    );
  }

  queueTaxAutomateReport(command: QueueTaxAutomateReportCommand): Observable<QueueReportResponse> {
    return this.http.post<QueueReportResponse>(
      `${environment.servicesApiUrl}/api/v4/organisations/${command.organisationId ?? ORGANISATION_PLACEHOLDER}/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/reports/tax-automate`,
      command,
    );
  }
}
